import { render, staticRenderFns } from "./StaticFilesList.vue?vue&type=template&id=04650d20&"
import script from "./StaticFilesList.vue?vue&type=script&lang=js&"
export * from "./StaticFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports